export default "__VITE_ASSET__DDZhuGca__"